import React, { useState, useEffect } from "react";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { formatosDeImagen as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoFormatoDeImagen as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { formatosDeImagenGet } from '../../services/hooli-services/FormatosDeImagen/FormatosDeImagenGet';
// recoil
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function FormatosDeImagen() {
    const [formatos, setFormatos] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const [{ status }, setRow] = useRecoilState(rowSelected)
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, formatosDeImagenGet, setFormatos);
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        formatos.map((item) => {
            const {
                formatoDeImagenId,
                formatoDeImagenVersion,
                formatoDeImagenNombre,
                formatoDeImagenCod,
                formatoDeImagenAncho,
                formatoDeImagenAlto
            } = item

            const formatoDeImagen = {
                id: formatoDeImagenId,
                version: formatoDeImagenVersion,
                [titles[0]]: formatoDeImagenNombre,
                [titles[1]]: formatoDeImagenCod,
                [titles[2]]: formatoDeImagenAncho,
                [titles[3]]: formatoDeImagenAlto
            }

            setRows(rows => [...rows, formatoDeImagen])
            return item
        });
    }, [formatos])

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="formatos de imagen" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};